const METRIC_IMAGES = {
  hrn: process.env.VUE_APP_API_URL + '/images/metrics/hrn-metric.png',
  hrn_fe: process.env.VUE_APP_API_URL + '/images/metrics/hrn-fe.png',
  hrn_gpd: process.env.VUE_APP_API_URL + '/images/metrics/hrn-gpd.png',
  hrn_po: process.env.VUE_APP_API_URL + '/images/metrics/hrn-po.png',
  hrn_np: process.env.VUE_APP_API_URL + '/images/metrics/hrn-np.png',

  iso12100: process.env.VUE_APP_API_URL + '/images/metrics/iso12100-metric.png',
  iso12100_quesitos:
    process.env.VUE_APP_API_URL + '/images/metrics/iso12100-sev.png',

  iso138491:
    process.env.VUE_APP_API_URL + '/images/metrics/iso138491-metric.png',
  iso138491_quesitos:
    process.env.VUE_APP_API_URL + '/images/metrics/iso138491-quesitos.png',
  iso138491a: process.env.VUE_APP_API_URL + '/images/metrics/iso138491a.png',
}

const PROTECTION_MODELS = {
  ACOPLAMENTOS_MANCAIS_EIXOS:
    process.env.VUE_APP_API_URL +
    '/images/protection-models/1_ACOPLAMENTOS_MANCAIS_EIXOS.png',
  ACRILICA_ARTICULADA:
    process.env.VUE_APP_API_URL +
    '/images/protection-models/2_ACRILICA_ARTICULADA.jpg',
  ACRILICA_CIRCULAR_FECHADA_2:
    process.env.VUE_APP_API_URL +
    '/images/protection-models/3_ACRILICA_CIRCULAR_FECHADA_2.jpg',
  ACRILICA_CIRCULAR_FECHADA:
    process.env.VUE_APP_API_URL +
    '/images/protection-models/4_ACRILICA_CIRCULAR_FECHADA.jpg',

  ACRILICA_CIRCULAR:
    process.env.VUE_APP_API_URL +
    '/images/protection-models/5_ACRILICA_CIRCULAR.jpg',
  BOMBA: process.env.VUE_APP_API_URL + '/images/protection-models/6_BOMBA.png',
  CABECEIRA_CORREIA_ESTEIRA:
    process.env.VUE_APP_API_URL +
    '/images/protection-models/7_CABECEIRA_CORREIA_ESTEIRA.png',
  CABECEIRA_INTERTRAVADA_ARTICULADA:
    process.env.VUE_APP_API_URL +
    '/images/protection-models/8_CABECEIRA_INTERTRAVADA_ARTICULADA.png',

  EIXO: process.env.VUE_APP_API_URL + '/images/protection-models/9_EIXO.png',
  ESMERIL_DUPLO:
    process.env.VUE_APP_API_URL +
    '/images/protection-models/10_ESMERIL_DUPLO.jpg',
  ESMERIL:
    process.env.VUE_APP_API_URL + '/images/protection-models/11_ESMERIL.jpg',
  FRESA_TORNO_2:
    process.env.VUE_APP_API_URL +
    '/images/protection-models/12_FRESA_TORNO_2.png',

  FRESA_TORNO:
    process.env.VUE_APP_API_URL +
    '/images/protection-models/13_FRESA_TORNO.png',
  FURADEIRA_ARTICULADA_2:
    process.env.VUE_APP_API_URL +
    '/images/protection-models/14_FURADEIRA_ARTICULADA_2.jpg',
  FURADEIRA_ARTICULADA:
    process.env.VUE_APP_API_URL +
    '/images/protection-models/15_FURADEIRA_ARTICULADA.jpg',
  FURADEIRA:
    process.env.VUE_APP_API_URL + '/images/protection-models/16_FURADEIRA.jpg',

  GRADEADO_2:
    process.env.VUE_APP_API_URL + '/images/protection-models/17_GRADEADO_2.png',
  GRADEADO_3_LADOS:
    process.env.VUE_APP_API_URL +
    '/images/protection-models/18_GRADEADO_3_LADOS.png',
  GRADEADO_3:
    process.env.VUE_APP_API_URL + '/images/protection-models/19_GRADEADO_3.png',
  GRADEADO_CANTO:
    process.env.VUE_APP_API_URL +
    '/images/protection-models/20_GRADEADO_CANTO.png',

  GRADEADO_INTERTRAVAMENTO_2:
    process.env.VUE_APP_API_URL +
    '/images/protection-models/21_GRADEADO_INTERTRAVAMENTO_2.png',
  GRADEADO_INTERTRAVAMENTO_3:
    process.env.VUE_APP_API_URL +
    '/images/protection-models/22_GRADEADO_INTERTRAVAMENTO_3.png',
  GRADEADO_INTERTRAVAMENTO:
    process.env.VUE_APP_API_URL +
    '/images/protection-models/23_GRADEADO_INTERTRAVAMENTO.png',
  GRADEADO:
    process.env.VUE_APP_API_URL + '/images/protection-models/24_GRADEADO.png',

  INFERIOR_CORREIA_ESTEIRA:
    process.env.VUE_APP_API_URL +
    '/images/protection-models/25_INFERIOR_CORREIA_ESTEIRA.png',
  ISOLAMENTO_DE_AREA:
    process.env.VUE_APP_API_URL +
    '/images/protection-models/26_ISOLAMENTO_DE_AREA.jpg',
  PERSONALIZADA:
    process.env.VUE_APP_API_URL +
    '/images/protection-models/27_PERSONALIZADA.jpg',
  POLIA: process.env.VUE_APP_API_URL + '/images/protection-models/28_POLIA.png',

  PROTECAO_PERIMETRAL:
    process.env.VUE_APP_API_URL +
    '/images/protection-models/29_PROTECAO_PERIMETRAL.jpg',
  PROTECAO_PLACA_TORNO:
    process.env.VUE_APP_API_URL +
    '/images/protection-models/30_PROTECAO_PLACA_TORNO.jpg',
  ROLETE_CORREIA:
    process.env.VUE_APP_API_URL +
    '/images/protection-models/31_ROLETE_CORREIA.png',
  SERRA_CIRCULAR:
    process.env.VUE_APP_API_URL +
    '/images/protection-models/32_SERRA_CIRCULAR.jpg',

  TORNO_2:
    process.env.VUE_APP_API_URL + '/images/protection-models/33_TORNO_2.jpg',
  TORNO_3:
    process.env.VUE_APP_API_URL + '/images/protection-models/34_TORNO_3.png',
  TORNO: process.env.VUE_APP_API_URL + '/images/protection-models/35_TORNO.jpg',
}

const SECURITY_DEVICES = {
  DETECCAO_PRESENCA:
    process.env.VUE_APP_API_URL +
    '/images/security-devices/step1/step1__1_deteccao_presenca.png',
  CHAVE_INTERTRAVAMENTO:
    process.env.VUE_APP_API_URL +
    '/images/security-devices/step1/step1__2_chave_intertravamento.png',
  RELE_SEGURANCA:
    process.env.VUE_APP_API_URL +
    '/images/security-devices/step1/step1__3_rele_seguranca.png',
  PARADA_EMERGENCIA:
    process.env.VUE_APP_API_URL +
    '/images/security-devices/step1/step1__4_parada_emergencia.png',
  SISTEMA_CONEXAO_SEGURANCA:
    process.env.VUE_APP_API_URL +
    '/images/security-devices/step1/step1__5_sistema_conexao_seguranca.png',
  CLP:
    process.env.VUE_APP_API_URL +
    '/images/security-devices/step1/step1__6_clp.png',

  CORTINA_LUZ:
    process.env.VUE_APP_API_URL +
    '/images/security-devices/step1/step2-deteccao-presenca/step2__1__1_cortina_luz.png',
  SCANNER_LASER:
    process.env.VUE_APP_API_URL +
    '/images/security-devices/step1/step2-deteccao-presenca/step2__1__2_scanner_laser.png',
  TAPETE_SENSIVEL_PRESSAO:
    process.env.VUE_APP_API_URL +
    '/images/security-devices/step1/step2-deteccao-presenca/step2__1__3_tapete_sensivel_pressao.png',
  BORDA_SENSIVEL_PRESSAO:
    process.env.VUE_APP_API_URL +
    '/images/security-devices/step1/step2-deteccao-presenca/step2__1__4_borda_sensivel_pressao.png',
  SENSORES_DETECCAO_MAOS:
    process.env.VUE_APP_API_URL +
    '/images/security-devices/step1/step2-deteccao-presenca/step2__1__5_sensores_deteccao_maos.png',

  SEM_CONTATO:
    process.env.VUE_APP_API_URL +
    '/images/security-devices/step1/step2-chave-intertravamento/step2__2__1_sem_contato.png',
  TRAVAMENTO_PROTECAO:
    process.env.VUE_APP_API_URL +
    '/images/security-devices/step1/step2-chave-intertravamento/step2__2__2_travamento_protecao.png',
  INTERTRAVAMENTO_LINGUETA:
    process.env.VUE_APP_API_URL +
    '/images/security-devices/step1/step2-chave-intertravamento/step2__2__3_intertravamento_lingueta.png',
  DOBRADICA:
    process.env.VUE_APP_API_URL +
    '/images/security-devices/step1/step2-chave-intertravamento/step2__2__4_dobradica.png',
  CHAVES_FIM_CURSO:
    process.env.VUE_APP_API_URL +
    '/images/security-devices/step1/step2-chave-intertravamento/step2__2__5_chaves_fim_curso.png',
  CHAVES_COM_SEGREDO:
    process.env.VUE_APP_API_URL +
    '/images/security-devices/step1/step2-chave-intertravamento/step2__2__6_chaves_com_segredo.png',

  CONFIGURAVEL_VIA_SOFTWARE:
    process.env.VUE_APP_API_URL +
    '/images/security-devices/step1/step2-rele-seguranca/step2__3__1_configuravel_via_software.png',
  MULTIFUNCIONAL:
    process.env.VUE_APP_API_URL +
    '/images/security-devices/step1/step2-rele-seguranca/step2__3__2_multifuncional.png',
  FUNCAO_SIMPLES:
    process.env.VUE_APP_API_URL +
    '/images/security-devices/step1/step2-rele-seguranca/step2__3__3_funcao_simples.png',
  ESPECIALIZADOS:
    process.env.VUE_APP_API_URL +
    '/images/security-devices/step1/step2-rele-seguranca/step2__3__4_especializados.png',

  ACIONAMENTO_POR_CABO:
    process.env.VUE_APP_API_URL +
    '/images/security-devices/step1/step2-parada-emergencia/step2__4__1_acionamento_por_cabo.png',
  CHAVE_HABILITACAO:
    process.env.VUE_APP_API_URL +
    '/images/security-devices/step1/step2-parada-emergencia/step2__4__2_chave_habilitacao.png',
  BOTOES_PULSADORES:
    process.env.VUE_APP_API_URL +
    '/images/security-devices/step1/step2-parada-emergencia/step2__4__3_botoes_pulsadores.png',
  DISPOSITIVOS_SONOROS:
    process.env.VUE_APP_API_URL +
    '/images/security-devices/step1/step2-parada-emergencia/step2__4__4_dispositivos_sonoros.png',
  COMANDO_BIMANUAL:
    process.env.VUE_APP_API_URL +
    '/images/security-devices/step1/step2-parada-emergencia/step2__4__5_comando_bimanual.png',
  PEDALEIRAS_ACIONAMENTO:
    process.env.VUE_APP_API_URL +
    '/images/security-devices/step1/step2-parada-emergencia/step2__4__6_pedaleiras_acionamento.png',
}

const CONFINED_SPACE_RISKS = {
  methodology: process.env.VUE_APP_API_URL + '/images/confined-space-risks/methodology.png',
}

export { METRIC_IMAGES, PROTECTION_MODELS, SECURITY_DEVICES, CONFINED_SPACE_RISKS }
